import moment from "moment";
moment.locale("it");

export default {
    methods: {
        convertInDateTimeFormat(date, type){
            if(type == 'date'){
                var newDate = new Date(date);
                //var os = newDate.getTimezoneOffset();
                //newDate = new Date(newDate.getTime() - os * 60 * 1000);
                return newDate.toJSON();
            }
            else{
                return this.convertTime(date)
            }
        },
        convertTime(timeString){
            let cdt = moment(timeString, 'HH:mm');
            let dateTime = cdt.format();
            console.log(dateTime);
            return dateTime
        }
    }
}